import clsx from "clsx";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

import LeftIcon from "../../assets/icons/svgs/card1.svg";
import RightIcon from "../../assets/icons/svgs/card2.svg";
import * as styles from "./styles.module.scss";

export const PhotoCards = () => {
  return (
    <section className={styles.main}>
      <div className={styles.photoCard}>
        <div className={styles.textWrapper}>
          <div className={styles.text}>
            <LeftIcon />
            <p>
              Multi-Regnskab er Danmarks eneste regnskabsprogram med særlig funktionalitet til at bogføre og lave
              årsrapport for et holdingselskab
            </p>
          </div>
        </div>
        <StaticImage
          src="../../assets/cards/girl.png"
          alt="Girl"
          placeholder="blurred"
          className={styles.cardImage}
          imgClassName={styles.img}
        />
      </div>
      <div className={styles.photoCard}>
        <StaticImage
          src="../../assets/cards/comp.png"
          alt="Comp"
          placeholder="blurred"
          className={styles.cardImage}
          imgClassName={styles.img}
        />
        <div className={clsx(styles.textWrapper, styles.flip)}>
          <div className={styles.text}>
            <RightIcon />
            <p>Det koster kun 500 kr om året (excl. moms) at benytte Multi-Regnskab for et simpelt holding</p>
          </div>
        </div>
      </div>
    </section>
  );
};
